import { get } from 'lodash';

import Axios from 'src/configs/axios';

const AUTH_API = {
  loginAPI: async (params: Auth.LoginRequestData) => {
    const response: any = await Axios.post('/auth/login', params);
    return response.data;
  },

  changePasswordAPI: async (params: any) => {
    const response: any = await Axios.post('/auth/force-change-password', params);
    return response.data;
  },

  getMeAPI: async () => {
    const response: Auth.ResponseRegister = await Axios.get('/users/me');
    const data = get(response, 'data', null);
    return data;
  },
};

export default AUTH_API;
